import { Box, Grid, Typography, styled } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';

export const Container = styled(Box)({
  height: 'auto',
  marginTop: '64px',
  padding: '30px 30px 30px 30px ',
});
export const SubContainer = styled(Box)({
  height: '100%',
});
export const SubNav = styled(Box)({
  height: 'fit-content',
  width: '100%',
});
export const ParentGrid = styled(Grid)({
  height: 'auto',
  width: '100%',
  // marginTop: '20px',
});

export const ChildGrid = styled(Grid)({
  height: '100%',
  width: '100%',
});

export const Title = styled(Typography)({
  fontFamily: 'DM Sans,sans-serif',
  fontWeight: 700,
  fontSize: '0.7em',
  color: '#526380',
});

export const ActivePolicyContainer = styled(Box)({
  height: 'auto',
  borderRadius: '10px',
  paddingLeft: '0 !important',
  position: 'relative',
  overflow: 'hidden',
});

export const PolicyContainerTitle = styled(Typography)({
  // backgroundColor: '#F9E1B4',
  color: ColorsV2.white,
  fontSize: '0.9em',
  padding: '1em',
  fontFamily: 'DM Sans, sans-serif',
});

export const PolicySubContainerTitle = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 700,
  fontSize: '0.9em',
  lineHeight: '26.04px',
  letterSpacing: '0.1px',
  color: '#1C1D21',
  marginBottom: '20px',
});

export const PolicySubContainerText = styled(Typography)({
  fontSize: '0.8em',
  fontFamily: 'DM Sans, sans-serif',
});

export const PolicySubContainerNormalText = styled(Typography)({
  fontSize: '19px',
  fontFamily: 'DM Sans, sans-serif',
  marginBottom: '10px',
});

export const PolicyContainerDesc = styled(Typography)({
  fontSize: '1.25em',
  fontFamily: 'DM Sans, sans-serif',
});

export const PolicyContainer = styled(Box)({
  width: '100%',
  height: 'auto',
  position: 'relative',
});

export const PolicySubContainer = styled(Box)({
  width: '100%',
});

export const ButtonContainer = styled(Box)({
  height: 'maxContent',
  width: 'maxContent',
  display: 'flex',
  alignItems: 'end',
  justifyContent: 'flex-end',
  paddingRight: '20px',
});
